import { useCallback } from "react";
import type { MutableRefObject } from "react";
import type { EventType } from "@/react/hooks/analytics/types";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { Form } from "@circle-react-uikit/Form";
import { ReasonFormFields, otherOption } from "./ReasonFormFields";

interface ReasonFormProps {
  eventType: EventType;
  localeRoot: string;
  onSubmit: () => void;
  reasonKeys: string[];
  triggerFormSubmitRef?: MutableRefObject<(() => Promise<void>) | null>;
}

export const ReasonForm = ({
  eventType,
  localeRoot,
  reasonKeys,
  onSubmit,
  triggerFormSubmitRef,
}: ReasonFormProps) => {
  const { trackEvent } = useEventsTracker();

  const handleSubmit = useCallback(
    (data: { reason: string; reason_description: string }) => {
      const surveyData = {
        reason: data.reason,
        reasonDescription: data.reason_description || "",
      };

      trackEvent(eventType, {
        reason: surveyData.reason,
        ...(surveyData.reason === otherOption &&
          surveyData.reasonDescription && {
            reason_description: surveyData.reasonDescription,
          }),
      });

      onSubmit();
    },
    [onSubmit, trackEvent, eventType],
  );

  return (
    <div>
      <Form onSubmit={handleSubmit} triggerFormSubmitRef={triggerFormSubmitRef}>
        <ReasonFormFields reasonKeys={reasonKeys} localeRoot={localeRoot} />
      </Form>
    </div>
  );
};
